import dropdown from './modules/dropdown';
import whatsappShare from './modules/whatsappShare';
import menuToggle from './modules/menuToggle';
import initCarousel from './modules/initCarousel';

whatsappShare();
dropdown();
menuToggle();
initCarousel();